import { Stack, Typography } from "@mui/material";
import { ReactComponent as WelcomeEira } from "../../assets/WelcomeEira.svg";
import { useTranslation } from "react-i18next";

interface ConfirmationScreenProps {}

const ConfirmationScreen: React.FC<ConfirmationScreenProps> = ({}) => {
  const { t } = useTranslation();

  return (
    <Stack
      display={"flex"}
      direction={"column"}
      spacing={1}
      alignItems={"center"}
      justifyContent={"center"}
      flex={1}
      height={"100vh"}
      sx={{
        backgroundColor: "rgba(252, 248, 248, 1)",
      }}
    >
      <WelcomeEira />
      <Typography
        sx={{
          fontSize: "24px",
          fontWeight: "400",
          color: "rgba(69, 71, 75, 1)",
        }}
      >
        {t("welcomeMsgHeader")}
      </Typography>
    </Stack>
  );
};

export default ConfirmationScreen;
